import { render } from "./AgenciesPage.vue?vue&type=template&id=42564318&ts=true"
import script from "./AgenciesPage.vue?vue&type=script&lang=ts"
export * from "./AgenciesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__